import {createStore} from 'redux';
import Utils from '../utils';

// Import the root reducer
import rootReducer from '../reducers/index';

const defaultState = {
    apiData       : [],
    currentRegion : '',
    currentRegionLabel : '',
    currentLocation : '',
    currentLocationLabel : '',
    currentLocationIndex : '',
    userValidated : Utils.getSessionCookie() 
}

const Store = createStore( rootReducer , defaultState)

export default Store


// WEBPACK FOOTER //
// ./src/js/stores/Store.js